import clsx from 'clsx'
import {FC, PropsWithChildren} from 'react'
import {HeaderProps} from 'react-table'
import { DetailBatchRecord } from '../../../../interfaces/batch'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<DetailBatchRecord>>
}

const CustomHeader: FC<Props> = ({className, title, tableProps}) => {
  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(className)}
      style={{cursor: 'pointer'}}
    >
      {title}
    </th>
  )
}

export {CustomHeader}
